import "bootstrap-icons/font/bootstrap-icons.css";

export default function Highlights() {
  return (
    <section className="highlights">
      <div className="container">
        <div className="highlights-heading text-center">
          <span className="section-eyebrow">WHY DESSERT HAVEN</span>

          <h2>Something sweet for every moment</h2>

          <p>
            Thoughtfully crafted treats, made to make every occasion a little
            more special.
          </p>
        </div>

        <div className="row g-4">
          <div className="col-md-4">
            <div className="highlight-card">
              <div className="highlight-icon">
                <i className="bi bi-box2-heart"></i>
              </div>

              <h3>Customizable Treat Boxes</h3>

              <p>
                Allow customers to mix and match from a selection of premium
                desserts, from macarons to brownies, creating the perfect treat
                box for any occasion.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="highlight-card">
              <div className="highlight-icon">
                <i className="bi bi-cake2"></i>
              </div>

              <h3>Gluten-Free Options</h3>

              <p>
                Include a range of gourmet, gluten-free, and dairy-free
                desserts, making indulgence accessible to everyone.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="highlight-card">
              <div className="highlight-icon">
                <i className="bi bi-truck"></i>
              </div>

              <h3>Same-Day Delivery</h3>

              <p>
                Offer convenient same-day delivery options to satisfy cravings
                or handle last-minute gift needs, perfect for birthdays or
                celebrations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
